(function () {
  const wrappers = document.querySelectorAll('.scroll-wrapper');
  if (!wrappers.length) return;

  wrappers.forEach((wrap) => {
    const grid = wrap.querySelector('.custom-product-grid');
    const track = wrap.querySelector('.custom-scrollbar-track');
    const thumb = wrap.querySelector('.custom-scrollbar-thumb');
    if (!grid || !track || !thumb) return;

    function updateThumb() {
      const { scrollWidth, clientWidth, scrollLeft } = grid;

      if (scrollWidth <= clientWidth) {
        track.style.display = 'none';
        return;
      }

      track.style.display = '';
      const visibleRatio = clientWidth / scrollWidth;
      const trackWidth = track.clientWidth;
      const thumbWidth = Math.max(20, trackWidth * visibleRatio);
      const maxLeft = trackWidth - thumbWidth;

      const left = maxLeft * (scrollLeft / (scrollWidth - clientWidth));

      thumb.style.width = `${thumbWidth}px`;
      thumb.style.transform = `translateX(${left}px)`;
    }

    // Chỉ activate khi xuất hiện trong viewport
    const observer = new IntersectionObserver(
      (entries, obs) => {
        if (entries[0].isIntersecting) {
          grid.addEventListener('scroll', updateThumb, { passive: true });
          window.addEventListener('resize', updateThumb);
          updateThumb();
          obs.disconnect();
        }
      },
      { threshold: 0 }
    );

    observer.observe(grid);
  });
})();
